module.exports = __webpack_public_path__ + "img/act-职位.11dbffcc.png";